import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bool',
  standalone: true,
})
export class BoolPipe implements PipeTransform {
  transform(value: string | boolean | number, ...args: unknown[]): boolean {
    
    if(typeof value === 'string') {
      
      value = value.toLowerCase();
      
      switch (value) {
        case 'okay': return true;
        case 'ok': return true;
        case 'yes': return true;
        case 'true': return true;

        case 'no': return false;
        case 'false': return false;
          
        default: return false;
      }

    } else if(typeof value === 'number') {
      return !!value;
    } else if(typeof value === 'boolean') {
      return value;
    } else {
      return false;
    }
  }
}
